export default {
  eventPropGetter: event => {
    const className = (() => {
      switch (event.bookingStatus) {
        case 'BOOKED':
          return 'rbc-booked';
        case 'INITIAL':
          return 'rbc-tentative';
        case 'CANCELED':
          return 'rbc-canceled';
        default:
          return '';
      }
    })();
    return { className };
  },
  getFlattenedEventSegments: events => {
    const flattenedEventSegments = [];

    events.map(event => {
      event.node.user_event_segments.edges.map(eventSegment => {
        flattenedEventSegments.push({
          title: `${event.node.event.title} - ${eventSegment.node.title}`,
          start: eventSegment.node.start_at,
          end: eventSegment.node.end_at,
          allDay: eventSegment.node.all_day,
          id: event.node.event.id,
          bookingStatus: event.node.booking_status
        });
        return eventSegment;
      });
      return event;
    });
    return flattenedEventSegments;
  }
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/bigCalendar.js